// extracted by mini-css-extract-plugin
module.exports = {"itemsSlider":"styles-module--itemsSlider--29jVw","back":"styles-module--back--1D5fc","next":"styles-module--next--PaH4o"};